import { WORKFLOW } from "./actionTypes"

const INIT_STATE = {
    workflow: null,
    loadingWorkflow: false,
    errorMessageWorkflow: null,
}

const WorkflowReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case WORKFLOW.PUT_WORKFLOW_CHANGE_STATUS.REQUEST:
            return {
                ...state,
                loadingWorkflow: true,
            };
        case WORKFLOW.PUT_WORKFLOW_CHANGE_STATUS.SUCCESS:
            return {
                ...state,
                loadingWorkflow: false,
                workflow: action.payload,
            };
        case WORKFLOW.PUT_WORKFLOW_CHANGE_STATUS.FAIL:
            return {
                ...state,
                loadingWorkflow: false,
                errorMessageWorkflow: action.payload,
            };
        case WORKFLOW.CLEAN_MESSAGE_WORKFLOW:
            return {
                ...state,
                errorMessageWorkflow: null,
                workflow: null,
            };
        default:
            return state;
    }
}
export default WorkflowReducer;